import React, { useEffect, useRef } from 'react';

// Öffentlicher Site-Key (sicher im Frontend). Ohne Key wird kein Widget gerendert
// und der anonyme Flow läuft ohne Captcha (z. B. lokale Builds ohne Cloudflare).
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export const isTurnstileEnabled = () => Boolean(SITE_KEY);

// Lädt das Cloudflare-Turnstile-Skript genau einmal (idempotent über window-Flag).
function loadTurnstileScript() {
  if (window.turnstile) return Promise.resolve();
  if (window.__turnstileLoading) return window.__turnstileLoading;
  window.__turnstileLoading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Turnstile-Skript konnte nicht geladen werden.'));
    document.head.appendChild(s);
  });
  return window.__turnstileLoading;
}

// Cloudflare-Turnstile-Widget (AUD-53). Meldet das (single-use) Token über onToken;
// bei Ablauf/Fehler wird onToken('') aufgerufen, damit der Aufrufer den Start sperrt.
const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let cancelled = false;

    loadTurnstileScript()
      .then(() => {
        if (cancelled || !containerRef.current || !window.turnstile) return;
        widgetIdRef.current = window.turnstile.render(containerRef.current, {
          sitekey: SITE_KEY,
          callback: (token) => onToken(token),
          'expired-callback': () => onToken(''),
          'error-callback': () => onToken(''),
        });
      })
      .catch(() => { /* Skript nicht ladbar → kein Token, Start bleibt gesperrt */ });

    return () => {
      cancelled = true;
      if (widgetIdRef.current && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch { /* noop */ }
      }
    };
  }, [onToken]);

  if (!SITE_KEY) return null;
  return <div ref={containerRef} style={{ marginTop: 4 }} />;
};

export default TurnstileWidget;
